import {
  userSlice,
  amlHistorySlice,
  twoFASlice,
  profileSlice,
  promoHistorySlice,
  amlCheckSlice,
  investigationHistorySlice,
  serviceOptionsSlice,
  paymentSlice,
  blockSlice,
  personalInfoModalSlice,
  twoFAActivateModalSlice,
  twoFADeActivateModalSlice,
  criticalBalanceAlertModalSlice,
  shareBalanceModalSlice,
  checkMethodModalSlice,
  checkBatchSlice,
  addressMonitoringSlice,
  receiveRemindersModalSlice,
  webSocketSlice,
  complianceAuthTokenSlice,
  complianceStatsSlice,
  complianceCategoryStatsSlice,
  complianceTransferSlice,
  complianceAlertStatsSlice,
  complianceAlertsSlice,
  complianceCustomersSlice,
  complianceAlertLevelsSlice,
  complianceListsSlice,
  externalServiceSlice,
  riskscoreProfilesSlice,
  alertRulesSlice,
  amlTraceSlice,
  amlTraceHistorySlice,
  notificationsSlice,
} from '../slices';

const { actions: userActions } = userSlice;
const { actions: amlHistoryActions } = amlHistorySlice;
const { actions: amlCheckActions } = amlCheckSlice;
const { actions: twoFAActions } = twoFASlice;
const { actions: profileActions } = profileSlice;
const { actions: promoHistoryActions } = promoHistorySlice;
const { actions: investigationHistoryActions } = investigationHistorySlice;
const { actions: serviceOptionsActions } = serviceOptionsSlice;
const { actions: paymentActions } = paymentSlice;
const { actions: blockActions } = blockSlice;
const { actions: personalInfoModalActions } = personalInfoModalSlice;
const { actions: twoFAActivateModalActions } = twoFAActivateModalSlice;
const { actions: twoFADeActivateModalActions } = twoFADeActivateModalSlice;
const { actions: criticalBalanceAlertModalActions } =
  criticalBalanceAlertModalSlice;
const { actions: shareBalanceModalActions } = shareBalanceModalSlice;
const { actions: checkMethodModalActions } = checkMethodModalSlice;
const { actions: checkBatchActions } = checkBatchSlice;
const { actions: addressMonitoringActions } = addressMonitoringSlice;
const { actions: receiveRemindersModalActions } = receiveRemindersModalSlice;
const { actions: webSocketActions } = webSocketSlice;
const { actions: complianceAuthTokenActions } = complianceAuthTokenSlice;
const { actions: complianceStatsActions } = complianceStatsSlice;
const { actions: complianceCategoryStatsActions } =
  complianceCategoryStatsSlice;
const { actions: complianceTransferActions } = complianceTransferSlice;
const { actions: complianceAlertStatsActions } = complianceAlertStatsSlice;
const { actions: complianceAlertsActions } = complianceAlertsSlice;
const { actions: complianceCustomersActions } = complianceCustomersSlice;
const { actions: complianceAlertLevelsActions } = complianceAlertLevelsSlice;
const { actions: complianceListsActions } = complianceListsSlice;
const { actions: externalServiceActions } = externalServiceSlice;
const { actions: riskscoreProfilesActions } = riskscoreProfilesSlice;
const { actions: alertRulesActions } = alertRulesSlice;
const { actions: amlTraceActions } = amlTraceSlice;
const { actions: amlTraceHistoryActions } = amlTraceHistorySlice;
const { actions: notificationsActions } = notificationsSlice;

export {
  userActions,
  amlHistoryActions,
  twoFAActions,
  profileActions,
  promoHistoryActions,
  amlCheckActions,
  investigationHistoryActions,
  serviceOptionsActions,
  paymentActions,
  blockActions,
  personalInfoModalActions,
  twoFAActivateModalActions,
  twoFADeActivateModalActions,
  criticalBalanceAlertModalActions,
  shareBalanceModalActions,
  checkMethodModalActions,
  checkBatchActions,
  addressMonitoringActions,
  receiveRemindersModalActions,
  webSocketActions,
  complianceAuthTokenActions,
  complianceStatsActions,
  complianceCategoryStatsActions,
  complianceTransferActions,
  complianceAlertStatsActions,
  complianceAlertsActions,
  complianceCustomersActions,
  complianceAlertLevelsActions,
  complianceListsActions,
  externalServiceActions,
  riskscoreProfilesActions,
  alertRulesActions,
  amlTraceActions,
  amlTraceHistoryActions,
  notificationsActions,
};
